import 'moment';
import 'handlebars/runtime';
import 'es5-shim';
import 'markets-components-core';
import 'markets-components-datepicker';
import 'markets-components-chartdatamanager';
import 'markets-components-svgchart';
import 'markets-components-datepicker/build/markets-components-datepicker.min.css';
import 'markets-components-svgchart/build/markets-components-svgchart.min.css';
